import {Action} from 'redux';
import {createAction} from '@reduxjs/toolkit';

export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';

export const showNotification = createAction<ShowNotificationActionPayload>(SHOW_NOTIFICATION);

export interface ShowNotificationActionPayload {
    message?: string;
    timeOut?: number;
    type?: string;
}

export interface ShowNotificationAction extends Action {
    payload: ShowNotificationActionPayload;
}
